import React from "react";
import "./GameSelector.css";
import TextLabel from "../../Controls/TextLabel.mjs";
import {Row, Col, ButtonGroup, Button, Input} from "reactstrap";
import appLib from "../../libs/appLib.mjs";

const G = window.glob;

const GameRow = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid('GameRow');
		this.rendergm = this.rendergm.bind(this);
		this.deleteGame = this.deleteGame.bind(this);
		this.stopGame = this.stopGame.bind(this);
	}
	deleteGame() {
		if ( ! window.confirm(G.label('ConfirmGameDeletion',{name:`“${this.props.game.name}”`})) ) return;
		this.setState({ loading: true });
		G.api(
			{ entity:"game", operation:"delete" },
			{ game: this.props.game.id }
		).then( async ()=>{
			await appLib.refreshAllData();
			this.setState({ loading: false });
		}).catch( (e)=>{
			console.error(e)
			this.setState({ loading: false });
		});
	}
	stopGame() {
		if ( ! window.confirm(G.label('ConfirmGameStop',{name:`“${this.props.game.name}”`})) ) return;
		if ( ! window.confirm(G.label('ConfirmGameStop2',{name:`“${this.props.game.name}”`})) ) return;
		this.setState({ loading: true });
		G.api(
			{ entity:"admin", operation:"stop" },
			{ game: this.props.game.id }
		).then( async ()=>{
			await appLib.refreshAllData();
			this.setState({ loading: false });
		}).catch( (e)=>{
			console.error(e)
			this.setState({ loading: false });
		});
	}
	rendergm() {
		if ( ! this.props.gm ) return '';
		return(
			<>
				<Button
					color={"warning"}
					className={"btn-icon"}
					disabled={ ! ['running','paused'].includes(this.props.game.status) }
					key={"stop"}
					onClick={()=>{ this.stopGame() }}
				>
					<i>
						<TextLabel value={"stop"} lang={"icon"} />
					</i>
					<b>
						<TextLabel value={"Stop"} />
					</b>
				</Button>
				<Button
					color={"danger"}
					className={"btn-icon"}
					disabled={ ['running','paused'].includes(this.props.game.status) }
					key={"delete"}
					onClick={()=>{ this.deleteGame() }}
				>
					<i>
						<TextLabel value={"delete"} lang={"icon"} />
					</i>
					<b>
						<TextLabel value={"Delete"} />
					</b>
				</Button>
			</>
		);
	}
	render() {
		return(
			<Row id={this.uid} className={"GameRow game-"+this.props.game.status}>
				<Col className={"GameName"}>
						{ this.props.game.name }
				</Col>
				<Col className={"GameStatus"}>
					{ this.props.game.status }
				</Col>
				<Col className={"GameButtons"}>
					<ButtonGroup>
						<Button
							className={"btn-icon"}
							color={"success"}
							onClick={ ()=>{
								G.setStatus('GameChosen', this.props.game, true);
								const s = G.getStatus('Scenario');
								G.getFeed( s.feed ).then(feed => {
									if ( feed.mailbox ) s.mailbox = feed.mailbox;
									if ( feed.telegram ) s.telegram = feed.telegram;
									G.setStatus('Scenario', s, true );
								});
								if ( this.props.game.status !== 'running' && this.props.admin ) {
									G.setCurrentPageParam('tab','Backstage');
								}
							}}
						>
							<i>
								<TextLabel value={"ok"} lang={"icon"} />
							</i>
							<b>
								<TextLabel value={"Choose"} />
							</b>
						</Button>
						{ this.rendergm() }
					</ButtonGroup>
				</Col>
				{ this.state.loading ? <div className={"curtain"}/>: ''}
			</Row>
		);
	}
};

const NewGame = class extends React.Component {
	constructor(props) {
		super(props);
		this.state={
			name:""
		};
		this.uid = G.generateUid('NewGame');
		this.setName = this.setName.bind(this);
		this.createGame = this.createGame.bind(this);
	}
	setName( v ) {
		const ns = { name: v, nameOk: true };
		if ( v.length < 6 ) {
			ns.nameOk = false;
		} else if ( this.props.games && this.props.games.find( g => ( g.name === v )) ) {
			ns.nameOk = false;
		}
		this.setState( ns );
	}
	createGame() {
		if ( ! this.state.nameOk ) return;
		this.setState({ creating: true });
		G.api(
			{ entity: 'game', operation: 'create' },
			{ game: this.state.name, real: this.state.real || undefined }
		).then( ()=>{
			setTimeout( ()=>{ G.processPoll( this.props.scenario.feedAdmin ); } );
			this.props.cancel();
		}).catch( (e)=>{
			console.error(e);
		}).finally( ()=>{
			this.setState({ creating: false });
		});
	}
	render() {
		return(
			<div className={"NewGame"} id={this.uid}>
				<h4>
					<TextLabel value={"New simulation"} />
				</h4>
				<form
					onSubmit={ (e)=>{
						e.preventDefault();
						if ( this.state.nameOk ) this.createGame();
					}}
				>
					<Row className={"align-items-center"}>
						<Col>
							<Input
								autoComplete={"off"}
								autoSave={"off"}
								autoFocus={true}
								name={"name"}
								type={"text"}
								valid={ !! this.state.nameOk }
								invalid={ ! this.state.nameOk }
								value={this.state.name||""}
								onChange={(e)=>{ this.setName( e.target.value );} }
							/>
						</Col>
						<Col>
							<ButtonGroup>
								<Button
									type={"submit"}
									disabled={ ! this.state.nameOk }
									className={"btn-icon"}
									color={"success"}
								>
									<i>
										<TextLabel value={"ok"} lang={"icon"} />
									</i>
									<b>
										<TextLabel value={"OK"} />
									</b>
								</Button>
								<Button
									className={"btn-icon"}
									color={"danger"}
									onClick={ ()=>{ this.props.cancel() } }
								>
									<b>
										<TextLabel value={"Cancel"} />
									</b>
									<i>
										<TextLabel value={"cancel"} lang={"icon"} />
									</i>
								</Button>
							</ButtonGroup>
						</Col>
					</Row>
				</form>
				{ this.state.creating ? <div className={"curtain"} /> : '' }
			</div>
		);
	}
}

const GameSelector = class extends React.Component {
	constructor(props) {
		super(props);
		const p = G.getStatus('Player');
		this.state = {
			scenario: G.getStatus('Scenario'),
			player: p,
			admin: !! p?.admin,
			canGM: p?.admin?.gameMaster,
			canLog: p?.admin?.seeLog
		};
		this.uid = G.generateUid('GameSelector');
		this.renderGames = this.renderGames.bind(this);
		this.renderControls = this.renderControls.bind(this);
	}
	componentDidMount() {
		const feed = this.state.scenario[ this.state.admin ? 'feedAdmin' : 'feed'];
		G.startPoll(feed,(x)=>{
				this.setState({ games: x.games });
			},this.uid
		);
		G.setStatus('gameIsReal', this.state.scenario.real );
		G.processPoll(feed);
	}
	componentWillUnmount() {
		G.stopPoll(this.uid);
	}
	renderGames() {
		if ( typeof this.state.games === 'undefined' ) return <div className={"curtain"}/>;
		const out = [];
		const gs = this.state.games.filter( g => (! g.stopped) );
		if ( gs.length ) {
			out.push(<h4 key={"title"}><TextLabel value={"Games"}/>: {gs.length}</h4>);
			gs.sort(
				(a,b)=>( a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 )
			).forEach( g => {
				out.push(
					<GameRow
						key={g.id}
						game={g}
						admin={ !! this.state.player?.admin }
						gm={this.state.canGM}
						log={this.state.canLog}
					/>
				);
			});
		} else {
			out.push(
				<div key={"NoGames"}>
					<h3 className={"NoGames"}>
						<TextLabel value={"NoGames"}/>
					</h3>
					<h5>
						<TextLabel value={"NoGamesDesc"}/>
					</h5>
				</div>
			);
		}
		if ( ! this.state.canGM && gs.length === 1 && gs[0].status === 'running' ) {
			setTimeout( ()=>{ G.setStatus('GameChosen', gs[0], true); })
		}
		return (
			<>
				<div className={"GamesList"} key={"games"}>
					{out}
				</div>
				{ this.state.scenario.customMessage && (
					<div className={"customMessage"} key={"customMessage"}>
						{ this.state.scenario.customMessage }
					</div>
				)}
			</>
		);
	}

	renderControls() {
		if (typeof this.state.games === 'undefined') return "";
		if ( ! this.state.canGM ) return "";
		if ( this.state.creatingSimulation ) return (
			<NewGame
				cancel={ ()=>{ this.setState({creatingSimulation: false })} }
				{...this.state}
			/>
		);
		return(
			<div className={"GamesControls"}>
				<Button
					className={"btn-icon"}
					color={"primary"}
					onClick={ ()=> { this.setState({ creatingSimulation: true} )} }
				>
					<i>
						<TextLabel value={"create"} lang={"icon"} />
					</i>
					<b>
						<TextLabel value={"New simulation"} />
					</b>
				</Button>
			</div>
		);
	}
	render() {
		return(
			<div className={"GameSelector"} id={this.uid}>
				<h1>
					<TextLabel value={"GameSelector"} />
				</h1>
				{ this.renderControls() }
				{ this.renderGames() }
				{ this.state.scenario?.real && (
					<div className={"warning"}>
						<h3>
							<TextLabel value={"StartRealGame"} />
						</h3>
						<div>
							{  G.getLanguage() === 'it' ? (
								<ul>
									<li>Eventuali sessioni aperte di questo stesso scenario verranno terminate</li>
									<li>Tutti i suggerimenti (hint) partiranno automaticamente</li>
									<li>Tutte le persone coinvolte verranno avvisate via mail e Telegram, se attivi</li>
									<li>Utilizzare solo per l’effettiva gestione di una vera crisi</li>
									<li>Questa operazione non può essere annullata</li>
								</ul>
							) : (
								<ul>
									<li>Open sessions in this scenario, if any, will be terminated</li>
									<li>Every defined hint will be triggered automatically</li>
									<li>All involved people will be warned via Telegram and email, if provided</li>
									<li>Use this setting only for the management of an actual crisis</li>
									<li>This operation cannot be undone</li>
								</ul>
							)}
						</div>
					</div>
				)}
			</div>
		)
	}
}

export default GameSelector;